import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=42b0c5bd&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=42b0c5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0c5bd",
  null
  
)

export default component.exports